import React from 'react';

import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

import { CARD_PRIMARY } from '../../constants/colors';
import { ICustomTooltipNEProps } from '../../interfaces/global';

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: CARD_PRIMARY
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: CARD_PRIMARY,
    boxShadow: '0px 4px 8px 0px rgba(15, 28, 20, 0.20);',
    padding: '10px'
  }
}));

const CustomTooltipNE = ({
  tooltipTitle,
  children,
  placement = 'bottom'
}: React.PropsWithChildren<ICustomTooltipNEProps>) => {
  return (
    <StyledTooltip title={tooltipTitle} placement={placement}>
      {children}
    </StyledTooltip>
  );
};

export default CustomTooltipNE;
